function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import RelateNodeGraph from '../relate/RelateNodeGraph';
import RobustLineIntersector from '../../algorithm/RobustLineIntersector';
var ConsistentAreaTester = /*#__PURE__*/function () {
  function ConsistentAreaTester() {
    _classCallCheck(this, ConsistentAreaTester);
    ConsistentAreaTester.constructor_.apply(this, arguments);
  }
  return _createClass(ConsistentAreaTester, [{
    key: "isNodeEdgeAreaLabelsConsistent",
    value: function isNodeEdgeAreaLabelsConsistent() {
      for (var nodeIt = this._nodeGraph.getNodeIterator(); nodeIt.hasNext();) {
        var node = nodeIt.next();
        if (!node.getEdges().isAreaLabelsConsistent(this._geomGraph)) {
          this._invalidPoint = node.getCoordinate().copy();
          return false;
        }
      }
      return true;
    }
  }, {
    key: "getInvalidPoint",
    value: function getInvalidPoint() {
      return this._invalidPoint;
    }
  }, {
    key: "hasDuplicateRings",
    value: function hasDuplicateRings() {
      for (var nodeIt = this._nodeGraph.getNodeIterator(); nodeIt.hasNext();) {
        var node = nodeIt.next();
        for (var i = node.getEdges().iterator(); i.hasNext();) {
          var eeb = i.next();
          if (eeb.getEdgeEnds().size() > 1) {
            this._invalidPoint = eeb.getEdge().getCoordinate(0);
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "isNodeConsistentArea",
    value: function isNodeConsistentArea() {
      var intersector = this._geomGraph.computeSelfNodes(this._li, true, true);
      if (intersector.hasProperIntersection()) {
        this._invalidPoint = intersector.getProperIntersectionPoint();
        return false;
      }
      this._nodeGraph.build(this._geomGraph);
      return this.isNodeEdgeAreaLabelsConsistent();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return ConsistentAreaTester;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { ConsistentAreaTester as default };
ConsistentAreaTester.constructor_ = function () {
  this._li = new RobustLineIntersector();
  this._geomGraph = null;
  this._nodeGraph = new RelateNodeGraph();
  this._invalidPoint = null;
  var geomGraph = arguments[0];
  this._geomGraph = geomGraph;
};